module.exports = __webpack_public_path__ + "static/SpinningHabitat2-28bcda7639019c9cd7167ba28d496d7f.mp4";